/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_Cee_Not_ConfiguredInputs */

const cs_property_registry_cee_not_configured = /** @type {(inputs: Property_Registry_Cee_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evidence exekucí není napojená — požádejte správce o přístup k CEE.`)
};

const en_property_registry_cee_not_configured = /** @type {(inputs: Property_Registry_Cee_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The enforcement register is not connected — ask your admin for CEE access.`)
};

/**
* | output |
* | --- |
* | "The enforcement register is not connected — ask your admin for CEE access." |
*
* @param {Property_Registry_Cee_Not_ConfiguredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_cee_not_configured = /** @type {((inputs?: Property_Registry_Cee_Not_ConfiguredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Cee_Not_ConfiguredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_cee_not_configured(inputs)
	return cs_property_registry_cee_not_configured(inputs)
});